<template>
  <div class="content">
    <h3 class="heading">●デリバリーサービス</h3>
    <p style="margin-bottom: 20px">
      以下のアプリから、香の川製麺のデリバリーをご利用いただけます。
    </p>
    <div class="banners">
      <a @click="openNetStore('https://demae-can.com/chain/top/312900/')" class="net-shop">
        <img :src="require('@/assets/img/net-shop/demaecan.png')" alt="" class="demaecan">
      </a>
      <a @click="openNetStore('https://app.menu.jp/')" class="net-shop">
        <img :src="require('@/assets/img/net-shop/menu.png')" alt="" class="menu">
      </a>
      <a @click="openNetStore('https://www.ubereats.com/jp')" class="net-shop">
        <img :src="require('@/assets/img/net-shop/ubereats.png')" alt="" class="ubereats">
      </a>
      <a @click="openNetStore('https://wolt.com/ja')" class="net-shop">
        <img :src="require('@/assets/img/net-shop/wolt.png')" alt="" class="wolt">
      </a>
    </div>
    <h3 class="heading" style="margin-top: 10px">●香の川製麺の味をご家庭で</h3>
    <img :src="require('@/assets/img/net-shop/externally-products.png')" alt="" style="margin-bottom: 20px; width: 100%">
    <p style="margin-bottom: 20px">
      スーパー、ドラッグストアなどでも香の川製麺の商品をお求めいただけます。
    </p>
    <button class="primary external" @click="openNetStore('https://www.joyfull.co.jp/sales/')">詳細はこちら</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'NetShopOthers',
  data() {
    return {
      title: 'ネットストア'
    }
  },
  created() {
  },
  methods: {
    ...mapActions('Native', ['actionRequestExternalLink']),
    openNetStore(url) {
      this.actionRequestExternalLink(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;

  .heading {
    text-align: left;
    background: #F4C600;
    font-size: 15px;
    font-weight: bold;
    color: #66160E;
    margin-bottom: 20px;
    padding: 15px;
  }

  p {
    font-size: 14px;
    text-align: left;
  }

  .banners {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .net-shop {
      width: 47.5%;
      height: 60px;
      background: #ffffff;
      border: 1px solid #5f230e;
      border-radius: 7px;
      box-shadow: 0 2px 1px 0 #d4d2cc;
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 80%;
        max-width: 267px;

        &.demaecan {
          margin-top: 3px;
        }
      }

      &.coming-soon {
        background: #cccccc;
        border: 1px solid #cccccc;
        box-shadow: none;
        color: #ffffff;
        font-weight: bold;
      }
    }
  }

  button {
    width: 100%;
    height: 44px;
    border-radius: 7px;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 15px;
    border: 1px solid #602209;
    background: #ffffff;
    color: #602209;

    &.primary {
      color: #ffffff;
      background: #602209;
    }
    &.external {
      background: #602209 url("~@/assets/img/net-shop/open_external.png") no-repeat 98%;
      background-size: 20px;
    }
  }
}

</style>
